
import { Form, Label, RequiredRule, SimpleItem, GroupItem } from "devextreme-react/form";
import React, { forwardRef, ReactElement, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Category, SubCategories } from "../account/detail/tabs/product/type";
import { RequestAdminCategories } from "./type";

export const CreateCategoryForm = forwardRef<any, { data: RequestAdminCategories, clearcomponent: boolean ,clearForm:boolean}>(
    ({ data, clearcomponent,clearForm }, ref) => {
        const localize = useSelector(getLocalized);
        const { token, lang } = useSelector(getApiParams);
        const [categories, setCategories] = useState<Category[]>([]);
        const [components, setComponents] = useState<ReactElement[]>([]);
        let length1 = 0;
        const getCategories = useCallback((async () => {
            const response: ApiResponse<Category[]> = await createRequest({
                method: "GET",
                url: "/api/dashboardview/categories",
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                setCategories(response.Result)
            }
        }), [token, lang])

        useEffect(()=>{
            data.Categories = [];
            data.Color = "";
            data.Description = "";
            data.Icon = "";
            data.Name = "";
            data.Order = 0;
            data.ParentCategoryId = "";
            data.Seo="";
            setComponents([])
        },[clearForm,data])
        const getSubCategories1 = async (id: any) => {
            clearForm = true
            const response: ApiResponse<SubCategories[]> = await createRequest({
                method: "GET",
                url: "/api/dashboardview/categories/" + id,
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                if ( response.Result.length !== 0) {

                    length1 = length1 + 1
                    //@ts-ignore
                    components ? setComponents((previous) => [
                        previous,
                        <GroupItem >
                            <SimpleItem
                                dataField={`Categories[${length1}]`}
                                editorType="dxLookup"
                                label={{ text: localize.getString("subCategory") }}
                                editorOptions={
                                    {
                                        searchEnabled: true,
                                        items: response.Result,
                                        displayExpr: "Name",
                                        valueExpr: "Id",
                                        onValueChanged: (e: any) => {
                                            data.Categories[length1] = e.value
                                            data.ParentCategoryId = e.value
                                            getSubCategories1(e.value)
                                        }
                                    }
                                }
                            >
                            </SimpleItem>
                        </GroupItem>
                    ]) : setComponents([])
                } else if (length1 === 0) {
                    setComponents([])
                    data.Categories = []
                    data.Categories[0] = id
                }else{
                    if(length1===0){
                        data.Categories = []
                        setComponents([])
                    }
                }
            }
        }


        useEffect(() => {
            if (clearcomponent === true) {
                setComponents([])
            }
        }, [clearcomponent])

        useEffect(() => {
            getCategories()

        }, [getCategories])
        return <form>

            <Form
                key="id"
                formData={data}
                ref={ref}
                showColonAfterLabel={true}
                validationGroup='createCategoryValidation'
            >
                <GroupItem colCount={2}>
                    <SimpleItem
                        dataField={"Name"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("name") }}
                    >
                        <Label visible={false} />
                        <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Description"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("description") }}
                    >
                        <Label visible={false} />
                        <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Order"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("order") }}
                    >
                        <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Seo"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("seo") }}
                    >
                        <Label visible={false} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Icon"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("icon") }}
                    >
                        <Label visible={false} />
                        <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Color"}
                        editorType={"dxTextBox"}
                        editorOptions={{
                            inputAttr: {
                                style: " text-transform: capitalize",
                            },
                        }}
                        label={{ text: localize.getString("color") }}
                    >
                        <Label visible={false} />
                        <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                        dataField={"Categories[0]"}
                        editorType="dxLookup"
                        label={{ text: localize.getString("parentCategory") }}
                        editorOptions={
                            {
                                searchEnabled: true,
                                items: categories,
                                displayExpr: "Name",
                                valueExpr: "Id",

                                onValueChanged: (e: any) => {
                                    data.Categories = []
                                    data.Categories[0] = e.value
                                    setComponents([])
                                    data.ParentCategoryId = e.value
                                    getSubCategories1(e.value)
                                }
                            }
                        }
                    >
                    </SimpleItem>
                    {components}
                </GroupItem>
            </Form>
        </form>
    }
)